import gql from 'graphql-tag'

export const booksQuery = gql`
  query booksQuery($userId: ID!) {
    allBooks {
      id
      name
      author
      totalPages
      bookPrefs(filter: { user: { id: $userId } }) {
        id
        maxPage
        percentRead
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/book.js